<div class="modal-avisos">
  <div class="modal-content">
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title modal-title text-center w-100">
        <img src="assets/img/bell-red.svg" class="mr-1" /><span
          class="badge badge-danger badge-avisos"
          >{{ total }}</span
        >
        {{ "pos-warnings.warnings" | translate }}
      </h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        (click)="close()"
      >
        &times;
      </button>
    </div>

    <!-- Modal body -->
    <div class="modal-body p-0 body-overflow">
      <div class="d-inline-flex p-3 w-100 bg-light">
        <div class="input-group flex-nowrap input-group-sm">
          <span class="input-group-text" id="addon-wrapping"
            ><i class="fa fa-search" aria-hidden="true"></i
          ></span>
          <input
            type="text"
            class="form-control"
            placeholder="{{ 'common.search' | translate }}"
            attr.aria-label="{{ 'common.search' | translate }}"
            aria-describedby="addon-wrapping"
            (input)="applyFilterPosWarnings($event)"
          />
        </div>
      </div>
      <div class="table-responsive px-3">
        <table class="table table-sm table-avisos">
          <thead>
            <tr>
              <th scope="col" sortable="indicator" (sort)="onSort($event)">
                {{ "pos-warnings.indicator" | translate }}
              </th>
              <th scope="col" sortable="comercialName" (sort)="onSort($event)">
                {{ "pos-warnings.comercialName" | translate }}
              </th>
              <th scope="col" sortable="description" (sort)="onSort($event)">
                {{ "pos-warnings.description" | translate }}
              </th>
              <th scope="col" sortable="date" (sort)="onSort($event)">
                {{ "pos-warnings.date" | translate }}
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of posWarningsPaginated; index as i">
              <td>
                <img
                  *ngIf="p.indicator === 'Verde'"
                  src="assets/img/avisos-level-green.svg"
                />
                <img
                  *ngIf="p.indicator === 'Naranja'"
                  src="assets/img/avisos-level-warning.svg"
                />
                <img
                  *ngIf="p.indicator === 'Rojo'"
                  src="assets/img/avisos-level-red.svg"
                />
              </td>
              <td>
                {{ p.comercialName }}
              </td>
              <td>
                {{ "posWarnings." + p.description | translate }}
                <br />
                <span>
                  <small *ngIf="p.detailError != null"
                    ><em>{{
                      "posWarnings." + p.detailError | translate
                    }}</em></small
                  >
                </span>
              </td>
              <td>
                {{ p.date }}
              </td>
              <td>
                <a (click)="viewDetail(p.pos)"
                  ><img src="assets/img/avisos-lnk.svg"
                /></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="refreshPosWarnings()"
          [maxSize]="3"
        >
        </ngb-pagination>
        <select
          class="custom-select"
          style="width: auto"
          [(ngModel)]="pageSize"
          (ngModelChange)="refreshPosWarnings()"
        >
          <option [ngValue]="10">10 {{ "common.perPage" | translate }}</option>
        </select>
      </div>
    </div>
  </div>
</div>
